import { inject } from '@angular/core';
import { ActionReducer } from '@ngrx/store';
import { SessionStorageService } from '../../../core/services/session-storage.service';
import AppState from '../../../app.state';
import { ResourcesGottenEvent, AuthorizationTokenGottenEvent, LogoutEvent } from './auth.events';
import { PersistedAuthData } from './auth.state';

export function authPersistenceMetaReducer(
  reducer: ActionReducer<AppState>,
): ActionReducer<AppState> {
  const sessionStorageService = inject(SessionStorageService);

  return (state, action) => {
    const nextState = reducer(state, action);

    try {
      if (action.type === AuthorizationTokenGottenEvent.type) {
        const auth = nextState.auth;

        if (
          typeof auth.authenticationToken === 'string' &&
          typeof auth.authorizationToken === 'string'
        ) {
          const data: PersistedAuthData = {
            authenticationToken: auth.authenticationToken,
            authorizationToken: auth.authorizationToken,
            resources: auth.resourcesInJWT,
            selectedUserKind: String(auth.selectedUserKind),
          };
          sessionStorageService.save(data);
        }
      } else if (action.type === ResourcesGottenEvent.type) {
        sessionStorageService.saveResources((action as any)['resources']);
      } else if (action.type === LogoutEvent.type) {
        sessionStorageService.clear();
      }
    } catch {
      // Silently handle errors — never interrupt the reducer flow
    }

    return nextState;
  };
}
